import { FC } from 'react';

import { FormSubmit } from 'libs/form/Form';
import { useTranslation } from 'libs/i18n';

import {
  Form,
  LegalClientFirstHeadFormType,
  getSchema,
} from '../../forms/legalClientFirstHeadForm';

import { FormContent, FormContentProps } from './FormContent';

export interface LegalClientFirstHeadFormProps extends FormContentProps {
  initialValues?: LegalClientFirstHeadFormType;
  onSubmit: FormSubmit<LegalClientFirstHeadFormType>;
}

export const LegalClientFirstHeadForm: FC<LegalClientFirstHeadFormProps> = ({
  initialValues,
  onSubmit,
  ...formProps
}) => {
  const { t } = useTranslation();

  const schema = getSchema(t);

  return (
    <Form
      initialReadOnly
      initialShowCopyButton
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </Form>
  );
};
